import { ActivityLog } from "../store/pomeriumApi";

export const getEntityUrl = (log: ActivityLog) => {
  switch (log?.entity?.type) {
    case "key_pair":
      return `/app/management/certificates/${log?.entity?.id}`;
    case "policy":
      return `/app/management/policies/${log?.entity?.id}/edit`;
    case "route":
      return `/app/management/routes/${log?.entity?.id}/edit`;
    case "settings":
      return "/app/settings";
    case "service_account":
      return `/app/management/service-accounts/${log?.entity?.id}/view`;
    default:
      return "";
  }
};
